module.exports = __webpack_public_path__ + "static/media/happiness-icon-negative.cb0a70da.svg";